const productCacheInvalidators = new Set();

export function registerProductCacheInvalidator(invalidator) {
  if (typeof invalidator !== 'function') {
    return () => {};
  }

  productCacheInvalidators.add(invalidator);

  return () => {
    productCacheInvalidators.delete(invalidator);
  };
}

export function invalidateAllProductCaches() {
  productCacheInvalidators.forEach((invalidate) => {
    try {
      invalidate();
    } catch {
      // Ignore invalidation failures so one cache does not block the others.
    }
  });
}
